import { Button } from "@/components/ui/button";
import {
  DialogHeader,
  DialogFooter,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import axiosInstance from "@/utils/axiosInstance";
import { singleProp } from "@/interface/dataInterface";
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { useRefresh } from "react-admin";
import { toast } from "sonner";
import orders from "@/tours-agent/orders";

interface Props {
  id: number;
  orderStatus: string;
  setStatusChanged?: Dispatch<SetStateAction<boolean>>;
}

export const AssignStatus: FC<Props> = ({
  id,
  orderStatus,
  setStatusChanged,
}) => {
  const refresh = useRefresh();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [currStatus, setCurrStatus] = useState("");
  const [status, setStatus] = React.useState("");

  useEffect(() => {
    if (orderStatus == "NEW_ORDER") return;
    setCurrStatus(orderStatus);
  }, [orderStatus]);

  const handleConfirm = (value: string) => {
    setStatus(value);
    setOpenDialog(true);
  };

  const submit = async () => {
    try {
      if (status === currStatus) return;
      await axiosInstance.put(`/taxi-orders/${id}`, {
        status,
      });

      if (setStatusChanged) setStatusChanged(true);

      toast(`Order status changed successfully`, {
        className: "absolute bottom-10 right-10 z-50",
      });

      refresh();
    } catch (err) {
      console.error("Failed to update order status", err);
      toast("Something went wrong", {
        className: "absolute bottom-10 right-10 z-50 text-red-500",
      });
    } finally {
      setOpenDialog(false);
    }
  };

  return (
    <>
      <Select onValueChange={handleConfirm} value={status || currStatus}>
        <SelectTrigger className="h-8 w-40 bg-muted">
          <SelectValue placeholder="Confirm Order" />
        </SelectTrigger>
        <SelectContent align="end">
          <SelectItem value="ACCEPTED">Accept</SelectItem>
          <SelectItem value="IN_PROGRESS">In progress</SelectItem>
          <SelectItem value="COMPLETED">Complete</SelectItem>
          <SelectItem value="REJECTED">Reject</SelectItem>
          <SelectItem value="CANCELLED">Cancel</SelectItem>
        </SelectContent>
      </Select>

      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <DialogHeader>
            <DialogTitle>Confirm</DialogTitle>
            <DialogDescription>
              Proceed with your action? You can edit status at any time
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenDialog(false);
                setStatus("");
              }}
            >
              No
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                submit();
              }}
            >
              Yes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AssignStatus;
